// removed by extract-text-webpack-plugin
module.exports = {"tooltip":"src-components-Tooltip-___index__tooltip___3fraI","tooltipImg":"src-components-Tooltip-___index__tooltipImg___2y6mS","tooltipTheme":"src-components-Tooltip-___index__tooltipTheme___1QTT2","tooltipThemeBigText":"src-components-Tooltip-___index__tooltipThemeBigText___3qmCz","tipBtn":"src-components-Tooltip-___index__tipBtn___32J8C","tipBtn2":"src-components-Tooltip-___index__tipBtn2___107dd"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Tooltip/index.css
// module id = 982
// module chunks = 3